import {
  createContext,
  type Dispatch,
  type RefObject,
  type SetStateAction,
} from 'react';

import {
  type ActiveTileRef,
  type MiniGameType,
} from '@/common/types/dice-game';

import { type DiceBoardDataReturnType } from './hooks/dice-board-data';

interface DiceGameContextType {
  dice: DiceBoardDataReturnType;
  diceFromRef: RefObject<HTMLImageElement> | null;
  energyFromRef: RefObject<HTMLImageElement> | null;
  setEnergyFromRef: (ref: RefObject<HTMLImageElement> | null) => void;
  setDiceFromRef: (ref: RefObject<HTMLImageElement> | null) => void;
  diceToRef: RefObject<HTMLImageElement> | null;
  setDiceToRef: (ref: RefObject<HTMLImageElement> | null) => void;
  energyToRef: RefObject<HTMLImageElement> | null;
  setEnergyToRef: (ref: RefObject<HTMLImageElement> | null) => void;
  flyingAnimation: 'tgem' | 'energy' | 'dice' | 'star' | null;
  setFlyingAnimation: Dispatch<
    SetStateAction<'tgem' | 'energy' | 'dice' | 'star' | null>
  >;
  cardsRewardFromRef: RefObject<HTMLElement> | null;
  setCardsRewardFromRef: Dispatch<
    SetStateAction<RefObject<HTMLElement> | null>
  >;
  isFlyingCardsReward: MiniGameType | null;
  setIsFlyingCardsReward: Dispatch<SetStateAction<MiniGameType | null>>;
  isRewardScaled: boolean;
  setIsRewardScaled: (value: boolean) => void;
  activeTileRef: RefObject<ActiveTileRef>;
}

const DiceGameContext = createContext({} as DiceGameContextType);

export { DiceGameContext };
